export const isFalseStrict = (value: unknown): value is false =>
  typeof value === 'boolean' && value === false;
